<template>
  <footer v-if="footer" :class="$options.name">
    <section :class="$options.name + '__wrap'">
      <section>
        <h5>Nice Bike</h5>
        <p class="address">
          <span>{{ footer.fields.addressStreet }},&nbsp;</span>
          <span>{{ footer.fields.addressStreet2 }}</span>
          <span>{{ footer.fields.addressCityState }}</span>
        </p>
        <p class="copyright">© {{ new Date().getFullYear() }} Nice Bike, LLC</p>
      </section>
      <section>
        <h5>Hours</h5>
        <RichText :value="footer.fields.hours" />
      </section>
      <section>
        <h5>Contact</h5>
        <p>{{ footer.fields.contactPhone }}</p>
        <p>
          <a
            class="email"
            :href="'mailto:' + footer.fields.contactEmail"
            aria-label="Send us an email"
          >{{ footer.fields.contactEmail }}</a>
        </p>
        <nav>
          <a
            v-if="footer.fields.socialInstagram"
            class="social"
            :href="footer.fields.socialInstagram"
            rel="noopener"
            target="_blank"
            aria-label="Follow us on Instagram"
          >
            <Icon name="social-instagram" :size="20" />
          </a>
          <a
            v-if="footer.fields.socialFacebook"
            class="social"
            :href="footer.fields.socialFacebook"
            rel="noopener"
            target="_blank"
            aria-label="Follow us on Facebook"
          >
            <Icon name="social-facebook" :size="20" />
          </a>
          <a
            v-if="footer.fields.socialTwitter"
            class="social"
            :href="footer.fields.socialTwitter"
            rel="noopener"
            target="_blank"
            aria-label="Follow us on Twitter"
          >
            <Icon name="social-twitter" :size="20" />
          </a>
          <button aria-label="Switch interface theme" class="social" @click="themeSwitch">
            <Icon name="sun" :size="20" />
          </button>
        </nav>
      </section>
    </section>
  </footer>
</template>
<script>
import Icon from "@/components/Icon";
import RichText from "@/components/RichText";
export default {
  name: "Footer",
  components: { Icon, RichText },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      footer: null
    };
  },
  methods: {
    themeSwitch() {
      let root = document.getElementsByTagName("html")[0];
      if (this.theme === "dark") {
        this.$store.dispatch("themeSwitch", "light");
      } else {
        this.$store.dispatch("themeSwitch", "dark");
      }
      root.setAttribute("data-theme", this.theme);
    }
  },
  mounted() {
    const contentful = require("contentful");
    const client = contentful.createClient({
      space: this.apiSpace,
      accessToken: this.apiToken
    });
    client
      .getEntry("68wFgErJVzPyBRZ5mBV2qU")
      .then(entry => {
        this.footer = entry;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>
<style lang="scss">
.Footer {
  border-top: rem(1) solid var(--base-ghost);
  &__wrap {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    max-width: rem(960);
    > * {
      flex: 1 1 100%;
      padding: rem(16);
      @include breakpoint(xsl) {
        max-width: calc(100% / 3);
      }
      > * + * {
        margin-top: rem(8);
      }
    }
    h5 {
      color: var(--base-mid);
    }
    h5,
    p.address {
      display: inline-flex;
      flex-wrap: wrap;
      span:last-child {
        flex-basis: 100%;
        @include breakpoint(xsl) {
          flex-basis: auto;
        }
      }
    }
    p.copyright {
      color: var(--base-mid);
      @include breakpoint(xsl) {
        margin-top: rem(16);
      }
    }
    p {
      @include typeSize(s, m);
    }
    nav {
      margin-left: rem(-4);
      > * {
        &.social {
          align-items: center;
          color: var(--base-mid);
          display: inline-flex;
          height: rem(32);
          justify-content: center;
          width: rem(32);
          + * {
            margin-left: rem(8);
          }
        }
        &:focus,
        &:hover {
          color: var(--highlight);
        }
      }
    }
  }
}
</style>